module.exports = __webpack_public_path__ + "img/cod-red.f7ffb864.svg";